<template>
  <div>
    <v-dialog v-model="rejectReasonModal" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Reason for Rejection
        </v-card-title>
        <v-card-text>
          <v-form ref="rejectReasonForm" lazy-validation>
            <v-text-field
              v-model="rejectReason"
              :rules="[(v) => !!v || 'Reason is required']"
              label="Reason *"
              required
            ></v-text-field>
            <v-radio-group
              v-model="selectedRejectSuggestion"
              @change="rejectReason = selectedRejectSuggestion"
            >
              <v-radio
                v-for="(suggestion, index) in rejectSuggestions"
                :key="index"
                :label="suggestion"
                :value="suggestion"
              ></v-radio>
            </v-radio-group>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="disabled"
                color="primary"
                flat
                @click="rejectItem(editedItem)"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-list class="pt-20 text-left">
      <h2 class="ml-3">Actions</h2>
      <v-divider></v-divider>
      <br />
      <v-btn
        :disabled="disabled"
        v-if="status == 1"
        color="success"
        @click="verifyItem"
      >
        Verify
      </v-btn>
      <v-btn
        :disabled="disabled"
        v-if="status == 1"
        color="error"
        @click="rejectReasonModal = true"
      >
        Reject
      </v-btn>
      <v-btn
        :disabled="disabled"
        v-if="status == 3"
        color="success"
        title="Change status to Pending"
        @click="rejectToPending"
      >
        Bring to Pending
      </v-btn>
      <v-btn
        :disabled="disabled"
        v-if="status == 4"
        color="success"
        title="Change status to Verified"
        @click="backToVerify"
      >
        Back to Verified
      </v-btn>
      <v-btn
        :disabled="disabled"
        v-if="status == 5"
        color="success"
        title="Change status to Signed by Investee"
        @click="bringToSignedByInvestee"
      >
        Bring to Signed by Investee
      </v-btn>
      <v-btn
        :disabled="disabled"
        v-if="status == 6"
        color="success"
        @click="approveItem"
      >
        Approve
      </v-btn>
      <v-btn
        :disabled="disabled"
        v-if="status == 7"
        color="success"
        @click="disburseItem"
      >
        Disburse
      </v-btn>
      <v-btn
        :disabled="disabled"
        v-if="status < 8"
        color="warning"
        title="Change status to Cancel"
        @click="cancelStatus"
      >
        Bring to Cancelled
      </v-btn>
    </v-list>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import HTTP from "@/utils/HTTP";
  import {
    cancelUrl,
    verifyUrl,
    rejectUrl,
    rejectToPendingUrl,
    processingToVerifyUrl,
    approveUrl,
    disburseUrl,
    bringToSignedByInvesteeUrl,
  } from "@/utils/variables";
  export default {
    props: ["status"],
    data() {
      return {
        disabled: false,
        selectedRejectSuggestion: "",
        rejectSuggestions: [
          "Missing information or paperwork",
          "High debt-income ratio",
          "Document verification failed",
          "Bad credit history",
          "Unstable employment history",
          "Minimum income requirement not met",
        ],
        rejectReasonModal: false,
        rejectReason: "",
      };
    },
    computed: {
      ...mapGetters(["indexData"]),
    },
    methods: {
      async cancelStatus() {
        var popUpMsg = confirm(
          "Are you sure you want to change this application status to Cancel?"
        );

        if (popUpMsg) {
          this.disabled = true;
          try {
            await HTTP().get(`${cancelUrl}/${this.$route.params.id}`);
            this.$emit("changeStatus", 6);
          } catch (error) {
            // console.log(error);
          } finally {
            this.disabled = false;
          }
        }
      },

      async verifyItem() {
        var popUpMsg = confirm(
          "Are you sure you want to verify this application?"
        );

        if (popUpMsg) {
          this.disabled = true;
          try {
            await HTTP().get(`${verifyUrl}/${this.$route.params.id}`);
            this.$emit("changeStatus", 6);
          } catch (error) {
            // console.log(error);
          } finally {
            this.disabled = false;
          }
        }
      },

      async rejectItem() {
        try {
          this.disabled = true;
          await HTTP().get(
            `${rejectUrl}/${this.$route.params.id}?reason=${this.rejectReason}`
          );
          this.$emit("changeStatus", 6);
        } catch (error) {
          // console.log(error);
        } finally {
          this.rejectReasonModal = false;
          this.disabled = false;
        }
      },

      async rejectToPending() {
        var popUpMsg = confirm(
          "Are you sure you want to change this application status to pending?"
        );

        if (popUpMsg) {
          this.disabled = true;
          try {
            await HTTP().get(`${rejectToPendingUrl}/${this.$route.params.id}`);
            this.$emit("changeStatus", 6);
          } catch (error) {
            // console.log(error);
          } finally {
            this.disabled = false;
          }
        }
      },

      async backToVerify() {
        var popUpMsg = confirm(
          "Are you sure you want to change this application status to Verified?"
        );

        if (popUpMsg) {
          this.disabled = true;
          try {
            await HTTP().get(
              `${processingToVerifyUrl}/${this.$route.params.id}`
            );
            this.$emit("changeStatus", 6);
          } catch (error) {
            // console.log(error);
          } finally {
            this.disabled = false;
          }
        }
      },

      async approveItem() {
        var popUpMsg = confirm(
          "Are you sure you want to approve this application?"
        );
        if (popUpMsg) {
          this.disabled = true;
          try {
            await HTTP().get(`${approveUrl}/${this.$route.params.id}`);
            this.$emit("changeStatus", 6);
          } catch (error) {
            // console.log(error);
          } finally {
            this.disabled = false;
          }
        }
      },

      async disburseItem() {
        var popUpMsg = confirm(
          "Are you sure you want to disburse for this application?"
        );
        if (popUpMsg) {
          this.disabled = true;
          try {
            await HTTP().get(`${disburseUrl}/${this.$route.params.id}`);
            this.$emit("changeStatus", 6);
          } catch (error) {
            // console.log(error);
          } finally {
            this.disabled = false;
          }
        }
      },

      async bringToSignedByInvestee() {
        var popUpMsg = confirm(
          "Are you sure you want to change this application status to Signed by Investee?"
        );
        if (popUpMsg) {
          this.disabled = true;
          try {
            await HTTP().get(
              `${bringToSignedByInvesteeUrl}/${this.$route.params.id}`
            );
            this.$emit("changeStatus", 6);
          } catch (error) {
            // console.log(error);
          } finally {
            this.disabled = false;
          }
        }
      },
    },
  };
</script>
